import axios from "axios";
import Config from "../config/";
import { authCheck } from './auth/actions';
import { handleSnackBar, removeUploadProgress, setReRender, setTriggerBlueprintValidation, updateUploadProgress } from "./global/actions";
import { getDetailsFromUrl } from "../services/blueprint";
import { validatationRoutes } from "../config/blueprintValidation";

class Methods {
	constructor() {
		this.get = this.get.bind(this);
	}

	async get(route, params) {

		try {
			let url = `${Config.apiUrl}${route}`;

			if (params) url = `${Config.apiUrl}${route}${this.mapParamsToQuery(params)}`;

			let result = await fetch(url, {
				method: "GET",
				headers: {
					Accept: "application/json",
					"Content-type": "application/json",
					Authorization: localStorage.getItem("token"),
				},
			});


			let jsonResponse;
			if (!result.ok) {
				const text = await result.text();
				throw new Error(text);
			} else jsonResponse = await result.json();

			return jsonResponse;
		} catch (err) {
			throw err;
		}
	}

	handleArrayValue(value) {
		try {
			if (value === undefined) return undefined;
			if (Array.isArray(value)) {
				value = value.filter((i) => i !== "");

				if (value.length) {
					return JSON.stringify(value);
				} else return undefined;
			}
			if (value === "" || value === null) return undefined;
			return value;
		} catch (error) { }
	}

	mapParamsToQuery(params, appendBlueprint) {

		let query = null;
		const self = this;
		const blueprintID = this.getBlueprintID()
		if (blueprintID == false) {
			alert('Invalid blueprint ')
			return
		}

		for (const [key, value] of Object.entries(params)) {
			let f = this.handleArrayValue(value);

			if (query) query = query + (f !== undefined ? `&${key}=${f}` : "");
			else query = f !== undefined ? `${key}=${value}` : "";
		}

		if (appendBlueprint) {
			return query != null ? `?${encodeURI(query)}&blueprint=${blueprintID}` : `?blueprint=${blueprintID}`
		}

		return `?${encodeURI(query)}`
	}

	mapParamsToSegment(params, appendBlueprint) {
		let query = null;
		const self = this;
		let isQuery = false;
		const blueprintID = this.getBlueprintID() || params?.blueprintId;
		if (blueprintID == false) {
			alert('Invalid blueprint ')
			return
		}


		if(Array.isArray(params)){
			query = params.length > 0 ? `/${params.join('/')}` : null
		}else if(params && typeof params === 'object'){
			let paramsKeys = Object?.keys(params);
			
			query = ''

			paramsKeys?.forEach((key, index) => {
				query += `${index === 0 ? '?' : '&'}${key}=${params[key]}`
			})

			if(query?.length > 0) isQuery = true;
		}


		if (appendBlueprint) {
			return isQuery? `${encodeURI(query)}&blueprint=${blueprintID}` :query != null ? `${encodeURI(query)}?blueprint=${blueprintID}` : `?blueprint=${blueprintID}`
		}

		// console.log('encode url----->', `?${encodeURI(query)}`)
		return `?${encodeURI(query)}`
	}

	getRequestOptions = (payload, isPostForm, zipFormat) => {

		// console.log('daaaaas------->', { payload, isPostForm, zipFormat })

		const blueprintID = this.getBlueprintID();

		// if (blueprintID == false) {
		// 	alert('Invalid blueprint')
		// 	return
		// }

		if (zipFormat)
			return {
				method: "POST",
				headers: {
					Accept: "application/json",
					"Content-type": "application/json",
					Authorization: localStorage.getItem("token")
				},
				body: JSON.stringify({ ...payload, blueprint: blueprintID }),
				responseType: 'blob'
			};

		if (isPostForm)
			return {
				method: "POST",
				headers: { Authorization: localStorage.getItem("token") },
				body: { ...payload, blueprint: blueprintID },
				redirect: "follow"
			};

		// console.log('after post form',)
		return {

			method: "POST",
			headers: {
				Accept: "application/json",
				"Content-type": "application/json",
				Authorization: localStorage.getItem("token"),
			},
			body: JSON.stringify({ ...payload, blueprint: blueprintID }),
		};
	};

	async post(route, payload, isPostForm) {
		try {
			let url = `${Config.apiUrl}${route}`;
			let result = await fetch(url, this.getRequestOptions(payload, isPostForm))
			let jsonResponse = await result.json();
			return jsonResponse;
		} catch (err) {
			throw err;
		}
	}

	async download(route, payload, isPostForm) {
		try {
			let url = `${Config.apiUrl}${route}`;
			let result = await fetch(url, this.getRequestOptions(payload, isPostForm, true))
			// let jsonResponse = await result.json();
			return result;
		} catch (err) {
			throw err;
		}
	}

	async downloadService(route, payload, query) {
		try {
			let url = `${Config.apiV2Url}${this.route[route]}`;
			if (query) url = `${url}${this.mapParamsToSegment(query, true)}`;
			const blueprintID = this.getBlueprintID()
			let transID = this.getTransactionId()

			let postPayload = {
				...payload,
				blueprint: blueprintID,
			}

			if (transID && payload?.transactionId == undefined) {
				postPayload.transactionId = transID
			}

			// let result = await fetch(url, this.getRequestOptions(postPayload, isPostForm, true))
			// // let jsonResponse = await result.json();
			// return result;
			const options = {
				method: "POST",
				headers: {
					Accept: "application/json",
					"Content-type": "application/json",
					Authorization: localStorage.getItem("token")
				},
				body: JSON.stringify({ ...payload, blueprint: blueprintID }),
				responseType: 'blob'
			}

			let result = await fetch(url, options);
			return result

		} catch (err) {
			throw err;
		}
	}




	async delete(route) {
		try {
			let url = `${Config.apiUrl}${route}`;

			let result = await fetch(url, {
				method: "DELETE",
				headers: {
					Accept: "application/json",
					"Content-type": "application/json",
					Authorization: localStorage.getItem("token"),
				},
			});
			let jsonResponse = await result.json();
			return jsonResponse;
		} catch (err) {
			throw err;
		}
	}

	async export(route) {
		try {
			let url = `${Config.apiUrl}${route}`;
			const splittedUrl = route.split("/");
			const blueprintName = splittedUrl[1];

			const response = await fetch(url, {
				method: "GET",
				headers: {
					"Content-Type": "application/octet-stream",
					Authorization: localStorage.getItem("token"),
				},
			});

			const blob = await response.blob();
			const downloadUrl = window.URL.createObjectURL(new Blob([blob]));
			const link = document.createElement("a");
			link.href = downloadUrl;
			link.setAttribute("download", `${blueprintName}.zip`);
			document.body.appendChild(link);
			link.click();
			link.parentNode.removeChild(link);
		} catch (err) {
			throw err;
		}
	}

	async postFile(route, payload, dispatch) {
		try {
			// console.log('options--3-->', payload)

			let url = `${Config.apiUrl}${route}`;
			let result = await fetch(url, {
				body: payload,
				headers: { Authorization: localStorage.getItem("token") },
				method: 'POST'
			})
			if (result.status === 401) {
				const setTimeoutFlag = localStorage.getItem("isSessionTimeOut");
				if (!setTimeoutFlag) {
					dispatch(authCheck());
					localStorage.setItem("isSessionTimeOut", true);
				}
			}
			let jsonResponse = await result.json()
			return jsonResponse;

		} catch (error) {
			throw error
		}
	}

	async uploadFileWithProgress(route, payload, dispatch, fileData) {
		try {
		  const url = `${Config.apiUrl}${route}`;
		  const { screen } = getDetailsFromUrl();
		  const response = await axios.post(url, payload, {
			headers: {
			  Authorization: localStorage.getItem("token"),
			  'Content-Type': 'multipart/form-data',
			},
			onUploadProgress: function (progressEvent) {
			  if (progressEvent.lengthComputable && fileData) {
				const percent = Math.round((progressEvent.loaded * 100) / progressEvent.total);
				const elapsedSeconds = (Date.now() - fileData.startTime) / 1000;
				const speed = progressEvent.loaded / elapsedSeconds; 
				const remainingBytes = progressEvent.total - progressEvent.loaded;
				const estimatedTimeLeft = speed > 0 ? Math.ceil(remainingBytes / speed) : null;

				dispatch(updateUploadProgress({ fileName: fileData.fileName, id: fileData.id, progress: percent, estimatedTimeLeft, status: "uploading", blueprint_id: fileData.blueprint_id }));
				
			  }
			}
		  });
		
		  if(fileData) {
			if (response?.data?.status) {
				dispatch(updateUploadProgress({ fileName: fileData.fileName, id: fileData.id, progress: 100, status: "completed", blueprint_id: fileData.blueprint_id }));
				dispatch(handleSnackBar({ open: true, message: `File uploaded`, severity: "success" }));
				if (screen === 'assets') {
					dispatch(setReRender());
				}
				setTimeout(()=> {
					dispatch(removeUploadProgress({ id: fileData.id }));
				}, 5000)
			} else {
				dispatch(handleSnackBar({ open: true, message: response?.data?.message ? response?.data?.message : "File uploading failed" , severity: "error" }));
				dispatch(removeUploadProgress({ id: fileData.id }));
			}
		  }
		  

		  return response.data;
		} catch (error) {
		  if (error.response && error.response.status === 401) {
			const timeoutFlag = localStorage.getItem("isSessionTimeOut");
			if (!timeoutFlag) {
			  dispatch(authCheck());
			  localStorage.setItem("isSessionTimeOut", true);
			}
		  }
		  dispatch(updateUploadProgress({ fileName: fileData.fileName, id: fileData.id, status: "error" }));
		  throw error;
		}
	  }

	
	async copyBlueprintZip(route, payload, dispatch) {
		// console.log("copyBlueprintZip-------------", {route, payload})
		try {
			let url = `${Config.apiV2Url}${route}`;
			let result = await fetch(url, {
				body: JSON.stringify(payload),
				headers: { Authorization: localStorage.getItem("token"), 'Content-Type': 'application/json' },
				method: 'POST',
			})
			if (result.status === 401) {
				const setTimeoutFlag = localStorage.getItem("isSessionTimeOut");
				if (!setTimeoutFlag) {
					dispatch(authCheck());
					localStorage.setItem("isSessionTimeOut", true);
				}
			}
			// let jsonResponse = await result.json()
			return result

		} catch (error) {
			throw error
		}
	}

	async postService(route, payload, query, dispatch, apiPort = false, signal) {
		let url = apiPort ? `${Config.api2V2Url}${this.route[route]}` : `${Config.apiV2Url}${this.route[route]}`;
		if (query) url = `${url}${this.mapParamsToSegment(query, true)}`;
		const blueprintID = this.getBlueprintID()
		let transID = this.getTransactionId()

	
		let postPayload;
		let isFormData = false;

		if(payload instanceof FormData){
			payload.append('blueprint', blueprintID)
			isFormData = true;
			postPayload = payload;
		}else{
			postPayload = {
				...payload,
				blueprint: blueprintID,
			}
		}

		if (transID && payload?.transactionId == undefined) {
			postPayload.transactionId = transID
		}

		const options = {
			method: "POST",
			headers: {
				Accept: isFormData ? "multipart/form-data" : "application/json",
				"Content-type": isFormData ? "multipart/form-data" : "application/json",
				Authorization: localStorage.getItem("token"),
			},
			body: isFormData ? postPayload : JSON.stringify(postPayload),
			signal: signal
		}

		try {
			let result = await fetch(url, options);
			if (result.status === 401) {
				const setTimeoutFlag = localStorage.getItem("isSessionTimeOut");
				if (!setTimeoutFlag) {
					dispatch(authCheck());
					localStorage.setItem("isSessionTimeOut", true);
				}
			}

			if (result.status === 504) {
				return {
					status: 504,
					response: {
						status: false,
						statusCode: 504,
						message: "Request timed out. Please try again.",
						suppressErrorToast: false,
					},
					url: url
				};
			}

			const triggerValidation = validatationRoutes.find(item => url?.includes(item.path)) || false;
			if(blueprintID && triggerValidation){
				dispatch(setTriggerBlueprintValidation());
			}

			let status = result.status;
			let response;
			try {
				response = await result.json();
			} catch (e) {
				response = null; 
			}
			return { status, response, url };
		} catch (error) {
			if (error.name === 'AbortError') {
				return {
					status: 0,
					response: { status: false, aborted: true, suppressErrorToast: true, message: "Request aborted" },
					url
				};
			}
			console.error("API Error:", error);
			return {
			  status: 0,
			  response: null,
			  error,
			  message: error.message,
			  url
			};
		
		}
	}


	async postV1Service(route, payload, query, dispatch, apiPort = false) {
		let url = apiPort ? `${Config.apiUrl}${this.route[route]}` : `${Config.apiUrl}${this.route[route]}`;
		if (query) url = `${url}${this.mapParamsToSegment(query, true)}`;
		const blueprintID = this.getBlueprintID()
		let transID = this.getTransactionId()

		// console.log('transID----', transID)

		let postPayload = {
			...payload,
			blueprint: blueprintID,
		}

		if (transID && payload?.transactionId == undefined) {
			postPayload.transactionId = transID
		}


		const options = {
			method: "POST",
			headers: {
				Accept: "application/json",
				"Content-type": "application/json",
				Authorization: localStorage.getItem("token"),
			},
			body: JSON.stringify(postPayload),
		}

		let result = await fetch(url, options);
		if (result.status === 401) {
			const setTimeoutFlag = localStorage.getItem("isSessionTimeOut");
			if (!setTimeoutFlag) {
				dispatch(authCheck());
				localStorage.setItem("isSessionTimeOut", true);
			}
		}
		let status = result.status;
		let response = await result.json();
		return { status, response };
	}

	async postFileService(route, payload, query, dispatch) {
		try {

			let url = `${Config.apiV2Url}${this.route[route]}`
			if (query) url = `${url}${this.mapParamsToSegment(query, true)}`;
			const blueprintID = this.getBlueprintID()
			let transID = this.getTransactionId()

			// let postPayload = {
			// 	...payload,
			// 	blueprint: blueprintID,
			// }

			// if (transID) {
			// 	postPayload.transactionId = transID
			// }

			// let result = await fetch(url, options);
			let result = await fetch(url, {
				body: payload,
				headers: { Authorization: localStorage.getItem("token") },
				method: 'POST'
			})
			if (result.status === 401) {
				const setTimeoutFlag = localStorage.getItem("isSessionTimeOut");
				if (!setTimeoutFlag) {
					dispatch(authCheck());
					localStorage.setItem("isSessionTimeOut", true);
				}
			}
			let status = result.status;
			let response = await result.json();
			return { status, response };
		}
		catch (error) {
			console.error('errorr', error)
		}

	}


	async getV1Service(route, params, dispatch, apiPort = false) {

		let url = apiPort ? `${Config.apiUrl}${this.route[route]}` : `${Config.apiUrl}${this.route[route]}`;
		if (params) url = `${url}${this.mapParamsToSegment(params, true)}`;

		const options = {
			method: "GET",
			headers: {
				Accept: "application/json",
				"Content-type": "application/json",
				Authorization: localStorage.getItem("token"),
			}
		}

		let result = await fetch(url, options);
		if (result.status === 401) {
			const setTimeoutFlag = localStorage.getItem("isSessionTimeOut");
			if (!setTimeoutFlag) {
				dispatch(authCheck());
				localStorage.setItem("isSessionTimeOut", true);
			}
		}
		let status = result.status;
		let response = await result.json();
		return { status, response };
	}

	async getService(route, params, dispatch, apiPort = false) {
		let url = apiPort ? `${Config.api2V2Url}${this.route[route]}` : `${Config.apiV2Url}${this.route[route]}`;
		if (params){
			url = `${url}${this.mapParamsToSegment(params, true)}`;
		} 

		const options = {
			method: "GET",
			headers: {
				Accept: "application/json",
				"Content-type": "application/json",
				Authorization: localStorage.getItem("token"),
			}
		}

		let result = await fetch(url, options);
		if (result.status === 401) {
			const setTimeoutFlag = localStorage.getItem("isSessionTimeOut");
			if (!setTimeoutFlag) {
				dispatch(authCheck());
				localStorage.setItem("isSessionTimeOut", true);
			}
		}
		let status = result.status;
		let response = await result.json();
		return { status, response };
	}

	getBlueprintID() {
		let url = window.location.pathname
		// console.log({ url })
		let segments = url.split('/')

		if (segments[3] === undefined || segments[3] === null) {
			return false
		}

		return segments[3]
	}

	getTransactionId() {
		let url = window.location.pathname
		let segments = url.split('/')

		if (segments[5] === undefined || segments[5] === null) {
			return false
		}

		return segments[5]
	}

	serverSentEventService(route, params, port2 = false) {
		let url = port2 ? `${Config.api2V2Url}${this.route[route]}` : `${Config.apiV2Url}${this.route[route]}`;
		let authorizationToken = decodeURI(localStorage.getItem("token"));
		if (params) url = `${url}${this.mapParamsToQuery(params, true)}&authorization=${authorizationToken}`;
		let eventSource = new EventSource(url);
		return eventSource;

	}

	singleBlueprintBackup(route, params) {
		let url = `${Config.apiUrl}${this.route[route]}`;
		let authorizationToken = decodeURI(localStorage.getItem("token"));
		if (params) url = `${url}${this.mapParamsToQuery(params, true)}&authorization=${authorizationToken}`;
		let eventSource = new EventSource(url, {heartbeatTimeout: 180000});
		return eventSource;
	}





}

export default Methods;
